import { RenderDetailViewProps } from 'interfaces/model.interface'

import { DealsData } from 'config/common/baseModel'

import Detail from './Detail'

export const TherapeuticsDealsView = ({
  model,
  data,
  setSelectedRow,
  viewData,
}: RenderDetailViewProps<Record<DealsData, string>>) => {
  if (!data) {
    return null
  }
  return (
    <Detail
      model={model}
      title='lookupVaccineName'
      deal={data}
      handleClose={() => setSelectedRow(null)}
      viewData={viewData}
    />
  )
}
